export default function randomString(length = 16): string {
  const alphabet =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  return new Array(length)
    .fill(true)
    .reduce(
      (string) =>
        string + alphabet.charAt(Math.floor(Math.random() * alphabet.length)),
      ''
    );
}
